import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { ListWrapper } from './list/ListWrapper'

const cieloMerchantBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/cielo-merchants',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const CieloMerchantPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={cieloMerchantBreadcrumbs}>Cielo Merchants</PageTitle>
      <ListWrapper />
    </>
  )
}

export default CieloMerchantPage
